<template>
  <thead>
    <tr>
      <td
        style="width: 300px;"
      >
        Termék
      </td>
      <td
        width="112"
      >
        Beszerzési ár
      </td>
      <td
        v-for="priceType in priceTypes"
        :key="priceType.id"
      >
        <div>{{ priceType.name }}</div>
        <div style="margin-top: 5px;">
          <el-switch v-model="priceType.is_active"></el-switch>
        </div>
      </td>
    </tr>
  </thead>
</template>

<script>
export default {
  props: ['priceTypes'],
};
</script>
